export const PWA_SW_PATH = '/pwa-sw.js';

export const PWA_PARTNER_ID = 61;
export const PWA_INSTALLED_STORAGE_KEY = 'pwa_installed';
export const PWA_CUSTOM_PROMOTION_SHOW_STORAGE_KEY = 'pwa_asked';
export const PWA_TRACKING_COOKIES_STORAGE_KEY = 'pwa_tracking';

export const PWA_INSTALL_BUTTON_TEXT_DEFAULT = 'Your Dating Application';
export const PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_1 = 'Hookup Application';
export const PWA_INSTALL_BUTTON_TEXT_SITE_GROUP_2 = 'Get Free Application';
